module.exports = {
  // 从数据库导入表单
  importFormFromDatabase: '从数据库导入表单',
  // 报表访问链接
  reportAccessLink: '报表访问链接',
  // 根据部门选择用户
  selectUsersByDepartment: '根据部门选择用户',
  // 同步数据库
  synchronizeTheDatabase: '同步数据库',
  addExistingUser: '添加已有用户',// 添加已有用户
  newAddUser: '新建用户',// 新建用户
  rolePermissionsConfiguration: '角色权限配置',// 角色权限配置
  departmentPermissionConfiguration: '部门权限配置',// 部门权限配置
  addSubmenu: '添加子菜单', // 添加子菜单
  dataPermissionRules: '数据权限规则' // 数据权限规则
}